import script from "./StarsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StarsComponent.vue?vue&type=script&setup=true&lang=js"

import "./StarsComponent.vue?vue&type=style&index=0&id=6c9af1ee&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9af1ee"]])

export default __exports__